<template>
  <ReportBaseSelectFilter
    class="time-worked-filter"
    label="Time worked"
    placeholder="All time worked types"
    query-property="time_worked"
    :options="allTimeWorkedTypes"
    :multiple="false"
    :allow-clear="false"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportTimeWorkedFilter',
  computed: {
    ...mapGetters(['allTimeWorkedTypes']),
  },
};
</script>
